import { useQuery } from '@tanstack/react-query'

import { useApi } from '@fortem-monorepo/react-spa'

export const useCurrencies = () => {
  const api = useApi()

  return useQuery({
    queryKey: ['static', 'currencies'],
    queryFn: () => api.misc.getCurrencies(),
  })
}
